var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("이벤트")])]), _c('div', {
    staticClass: "contents-area__inner"
  }, [_c('router-board', {
    attrs: {
      "code": "event",
      "skin": "event"
    }
  })], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }